var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row cemetery-search-sector" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("TableSearch", {
          ref: `tblSearch-${_vm.panelId}`,
          attrs: {
            route: _vm.url.search,
            startLoad: _vm.tableStartLoad,
            settings: _vm.tableSettings,
            columns: _vm.tableColumns,
            externalFilters: _vm.form,
            btnSearchFilters: false,
            btnClearFilters: false,
            showTitleData: false,
            encodeParamsQueryString: ["data"],
            tableWrapperClass: "bg-lilac-light",
            tableClass: _vm.tableClass,
          },
          on: {
            search: _vm.onSearched,
            resetSearch: _vm.onResetSearch,
            errorLoad: _vm.showError,
          },
          scopedSlots: _vm._u([
            {
              key: "body",
              fn: function ({ columns, row }) {
                return [
                  _vm._l(columns, function (column, index) {
                    return [
                      column.field || column.field_label
                        ? [
                            column.actionFnName &&
                            column.actionPermissionName &&
                            _vm.callFn(column.actionPermissionName, column)
                              ? [
                                  _c(
                                    "td",
                                    {
                                      key: `${column}-${index}`,
                                      class: column.class,
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          key: `${column}-${index}`,
                                          staticClass:
                                            "btn btn-link min-w-auto font-small text-decoration-none text-align-inherit text-transform-none z-depth-0 m-0 p-0",
                                          attrs: {
                                            "data-toggle": "tooltip-city",
                                            title: _vm.$t(
                                              `${column.actionTitle}`
                                            ),
                                            type: "button",
                                            disabled: false,
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.callFn(
                                                column.actionFnName,
                                                row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.columnValue(row, column)
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              : [
                                  _c("td", {
                                    key: `${column}-${index}`,
                                    class: column.class,
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.columnValue(row, column)
                                      ),
                                    },
                                  }),
                                ],
                          ]
                        : [
                            _c(
                              "column-actions",
                              {
                                key: `${column}-${index}`,
                                attrs: { row: row, index: index },
                              },
                              [
                                _vm.hasGeometry(row)
                                  ? [
                                      _c(
                                        "li",
                                        { staticClass: "list-group-item" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-map-marked-alt action view-on-map",
                                            attrs: {
                                              disabled: false,
                                              "data-toggle": "tooltip-city",
                                              "data-placement": "left",
                                              title: _vm.$t(
                                                `${_vm.translateID}.buttons.view_on_map`
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.onViewOnMap(row)
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ],
                    ]
                  }),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }